'use client';

import { FormEvent, useState, useTransition } from 'react';

import { useRouter } from 'next/navigation';

import { Button } from '@kit/ui/button';
import { Input } from '@kit/ui/input';
import { Spinner } from '@kit/ui/spinner';

export function ComingSoonForm() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isPending, startTransition] = useTransition();
  const router = useRouter();

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError('');

    startTransition(async () => {
      try {
        const response = await fetch('/api/coming-soon/verify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ password }),
        });

        const data = await response.json();

        if (response.ok) {
          // Redirect to home page
          router.push('/');
          router.refresh();
        } else {
          setError(data.error || 'Invalid password');
        }
      } catch (err) {
        console.error('Error verifying password:', err);
        setError('An error occurred. Please try again.');
      }
    });
  };

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-6">
      <div className="space-y-2">
        <Input
          type="password"
          placeholder="Enter access password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full"
          disabled={isPending}
          required
        />
        {error && (
          <p className="text-sm text-red-500 dark:text-red-400">{error}</p>
        )}
      </div>
      <Button
        type="submit"
        className="w-full"
        disabled={isPending || !password}
      >
        {isPending ? (
          <>
            <Spinner className="mr-2 h-4 w-4" />
            Verifying...
          </>
        ) : (
          'Access Site'
        )}
      </Button>
    </form>
  );
}